<template v-slot:append>
  <v-dialog max-width="95%" persistent no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
    <v-card min-height="75%" min-width="95%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          貨物検索
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-expansion-panels v-model="expansionPanel" multiple flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row ref="_calcHeight-Row1">
                  <v-col :cols="12">
                    <dd-sub-header>
                      検索条件
                    </dd-sub-header>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row no-gutters align-content="center" ref="_calcHeight-Row2">
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <div style="width:48%" class="px-1">
                        <dd-date-box
                          label="受注日"
                          v-model="conditions.juchuYmdFrom"
                          ref="juchuYmdFrom"
                          :readonly="false"
                          />
                      </div>
                      <div style="width:4%" class="mt-2 mp-0">～</div>
                      <div style="width:48%" class="px-1">
                        <dd-date-box
                          v-model="conditions.juchuYmdTo"
                          ref="juchuYmdTo"
                          :readonly="false"
                          />
                      </div>
                    </v-row>
                  </v-col>

                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="受注営業所コード/名称"
                          v-model="conditions.juchuEigyoshoCd"
                          ref="juchuEigyoshoCd"
                          :required=false
                          :length=100
                          :valueType="ctypes.InputTypes.Free"
                          :itemList="filteredEigyoshoList"
                          titleText="営業所検索"
                          item-value="eigyoshoCd"
                          item-text="eigyoshoNm"
                          :headerList="mstEigyoshoHeader"
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="売上営業所コード/名称"
                          v-model="conditions.sagyoEigyoshoCd"
                          ref="sagyoEigyoshoCd"
                          :required=false
                          :length=100
                          :valueType="ctypes.InputTypes.Free"
                          :itemList="filteredEigyoshoList"
                          titleText="営業所検索"
                          item-value="eigyoshoCd"
                          item-text="eigyoshoNm"
                          :headerList="mstEigyoshoHeader"
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="荷主コード/名称"
                          v-model="conditions.ninushiCd"
                          ref="ninushiCd"
                          :length="100"
                          :required="false"
                          :valueType="Ctrls.InputTypes.Free"
                          titleText="取引先マスタ検索"
                          :headerList="mstTorihikisakiHeader"
                          item-value="torihikisakiCd"
                          item-text="torihikisakiNm"
                          :itemList="filteredTokuisakiList"/>
                      </v-col>
                    </v-row>
                  </v-col>

                </v-row>

                <v-row no-gutters align-content="center" ref="_calcHeight-Row3">
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <div style="width:48%" class="px-1">
                        <dd-date-box
                          label="請求日"
                          v-model="conditions.seikyuYmdFrom"
                          ref="seikyuYmdFrom"
                          :readonly="false"
                          />
                      </div>
                      <div style="width:4%" class="mt-2 mp-0">～</div>
                      <div style="width:48%" class="px-1">
                        <dd-date-box
                          v-model="conditions.seikyuYmdTo"
                          ref="seikyuYmdTo"
                          :readonly="false"
                          />
                      </div>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-radio-group class="px-1 mt-1"
                        label="検索対象"
                        v-model="conditions.nippoStatus"
                        row>
                        <dd-radio-button
                          label="全て"
                          value="99"
                        />
                        <dd-radio-button
                          label="日報なし"
                          value="02"
                        />
                        <dd-radio-button
                          label="日報あり"
                          value="03"
                        />
                      </v-radio-group>
                    </v-row>
                  </v-col>
                  <v-col :cols="6">
                    <v-row no-gutters align-content="center">
                      <dd-checkbox class="mt-1"
                        label="未請求のみ対象"
                        v-model="conditions.miseikyuTaishoFlg"
                        ref="miseikyuTaishoFlg"
                        />
                      <v-spacer />
                      <dd-checkbox class="mt-1"
                        label="請求・売上金額不一致のみ対象"
                        v-model="conditions.kingakuFuseigoFlg"
                        ref="kingakuFuseigoFlg"
                        />
                      <v-toolbar class="pa-0 ma-0" flat dense>
                        <v-spacer />
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onSearchButtonClick">
                          検索
                        </dd-default-button>
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onClearButtonClick">
                          クリア
                        </dd-default-button>
                      </v-toolbar>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row no-gutters align-content="center" ref="_calcHeight-Row4">
            <v-col :cols="6">
              <dd-sub-header>
                一覧
              </dd-sub-header>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box v-model="searchText" :length=10 />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="検索結果"
                v-model="rowCount"/>
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="絞込結果"
                v-model="filteredRowCount"/>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <dd-data-table
                v-model="selectedItem"
                calculate-widths
                :height="calcHeightTable"
                item-key="id"
                showSelect
                singleSelect
                @dblclick:row="onRowDoubleClick"
                @click:row="onRowClick"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                :header-props="{sortByText: '並び替え'}"
                :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                loading-text="検索中のため、少々お待ちください。"
                :itemsPerPage=500
                fixed-header
                locale="ja-jp"
                no-data-text="利用可能なデータはありません。"
                dense
                :page.sync ="page"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          @click="onCloseClick">
          閉じる
        </dd-footer-button>
        <v-spacer></v-spacer>
        <dd-footer-button
          :disabled="isSelectButtonDisabled"
          @click="onSelectButtonClick">
          選択
        </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import controls from '@/rahmen/controls'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'

import { mapGetters } from 'vuex'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdDateBox = () => import('@/components/DdDateBox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')

export default {
  name: 'ThKamotsuNoSearchDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdDateBox,
    DdCodeTextBox,
    DdRadioButton,
    DdCheckbox,
    DdDataTable,
    DdRowCountBox,
    DdDefaultButton,
    DdNarrowDownTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String
  },
  data: () => ({
    conditions: {
      juchuYmdFrom: '',
      juchuYmdTo: '',
      seikyuYmdFrom: '',
      seikyuYmdTo: '',
      juchuEigyoshoCd: '',
      sagyoEigyoshoCd: '',
      ninushiCd: '',
      nippoStatus: '',
      miseikyuTaishoFlg: true,
      kingakuFuseigoFlg: false
    },
    page: 1,
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    expansionPanel: [0, 1],
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    selectedItem: []
    /*
     *
     */
  }),
  created () {
    console.log('screen created')
    this.$store.dispatch('system/setViewTitle', '貨物検索')
    this.mstEigyoshoHeader = header.mstEigyoshoHeaders
    this.mstTorihikisakiHeader = header.mstTorihikisakiHeaders
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.juchuYmd = filter.dateFormatter(elem.juchuYmd)
        if (elem.seikyuYoteiYmd) { elem.seikyuYoteiYmd = filter.dateFormatter(elem.seikyuYoteiYmd) }
        if (elem.seikyuKingaku) {
          elem.seikyuKingaku = filter.numericFormatter(elem.seikyuKingaku) + '円'
        } else {
          elem.seikyuKingaku = '0円'
        }
        if (elem.uriageKingaku) {
          elem.uriageKingaku = filter.numericFormatter(elem.uriageKingaku) + '円'
        } else {
          elem.uriageKingaku = '0円'
        }
        if (elem.seikyuZumiFlg != null) { elem.seikyuZumiFlg = elem.seikyuZumiFlg ? '請求済み' : '未請求' }
        return elem
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isSelectButtonDisabled () {
      return this.selectedItem.length === 0
    },
    calcHeightTable () {
      if (this.expansionPanel.length === 1) {
        return this.tableHeight * 0.8
      }
      return this.tableHeight * 0.44
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThKamotsuNoSearchDialog.defineHeaderPromise')
            self.headers = [
              { text: '貨物No', value: 'juchuNo' },
              { text: '受注日', value: 'juchuYmd' },
              { text: '受注営業所', value: 'juchuEigyoshoNm' },
              { text: '荷主', value: 'ninushiNm' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '卸先', value: 'oroshisakiNm' },
              { text: '着地', value: 'chakuchiNm' },
              { text: '請求計上日', value: 'seikyuYoteiYmd', align: 'center' },
              { text: '請求金額', value: 'seikyuKingaku', align: 'right', filterable: false },
              { text: '売上金額', value: 'uriageKingaku', align: 'right', filterable: false },
              { text: '請求状況', value: 'seikyuZumiFlg', align: 'center' },
              { text: '作業明細ID', value: 'sagyoMeisaiId', align: ' d-none' }]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          var miseikyuTaishoFlg = c.kamotsuMiseikyuTaishoFlg !== 'false'
          var kingakuFuseigoFlg = c.kamotsuKingakuFuseigoFlg === 'true'
          this.conditions.juchuYmdFrom = c.kamotsuJuchuYmdFrom !== undefined && c.kamotsuJuchuYmdFrom !== '' && c.kamotsuJuchuYmdFrom !== null ? c.kamotsuJuchuYmdFrom : ''
          this.conditions.juchuYmdTo = c.kamotsuJuchuYmdTo !== undefined && c.kamotsuJuchuYmdTo !== '' && c.kamotsuJuchuYmdTo !== null ? c.kamotsuJuchuYmdTo : ''
          this.conditions.seikyuYmdFrom = c.kamotsuSeikyuYmdFrom !== undefined && c.kamotsuSeikyuYmdFrom !== '' && c.kamotsuSeikyuYmdFrom !== null ? c.kamotsuSeikyuYmdFrom : ''
          this.conditions.seikyuYmdTo = c.kamotsuSeikyuYmdTo !== undefined && c.kamotsuSeikyuYmdTo !== '' && c.kamotsuSeikyuYmdTo !== null ? c.kamotsuSeikyuYmdTo : ''
          this.conditions.juchuEigyoshoCd = c.kamotsuJuchuEigyoshoCd !== undefined && c.kamotsuJuchuEigyoshoCd !== '' && c.kamotsuJuchuEigyoshoCd !== null ? c.kamotsuJuchuEigyoshoCd : ''
          this.conditions.sagyoEigyoshoCd = c.kamotsuSagyoEigyoshoCd !== undefined && c.sagyoEigyoshoCd !== '' && c.sagyoEigyoshoCd !== null ? c.sagyoEigyoshoCd : ''
          this.conditions.ninushiCd = c.kamotsuNinushiCd !== undefined && c.kamotsuNinushiCd !== '' && c.kamotsuNinushiCd !== null ? c.kamotsuNinushiCd : ''
          this.conditions.nippoStatus = c.kamotsuNippoStatus !== undefined && c.kamotsuNippoStatus !== '' && c.kamotsuNippoStatus !== null ? c.kamotsuNippoStatus : '99'
          this.conditions.miseikyuTaishoFlg = miseikyuTaishoFlg
          this.conditions.kingakuFuseigoFlg = kingakuFuseigoFlg
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThKamotsuNoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('ThKamotsuNoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            resolve()
          })
        },
        settingViewScroll: () => {
          return true
        },
        restoreViewPromise: (c) => {
          console.log('ThKamotsuNoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThKamotsuNoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.$emit('close', f.item)
      // this.initBindVariables()
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
    },
    onRowClick: function (e) {
      /**
       * 選択処理
       * @event Click
       * @type {Event}
       */
      console.log('row clicked', e, this.searchText)
      this.selectedItem = [e]
      /*
      if (this.selectedItem.length === 0) {
        this.selectedItem = [e]
      } else {
        this.selectedItem = []
      }
      */
    },
    onSelectButtonClick: function (e) {
      /**
       * 選択ボタン押下処理
       * @event click
       * @type {Event}
       */
      console.log('select clicked', e, this.selectedItem)
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        this.$emit('close', this.selectedItem[0])
      }
      // this.initBindVariables()
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCThrcod00101/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChacheById('THRCOD0010', cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            kamotsuJuchuYmdFrom: self.conditions.juchuYmdFrom ? self.conditions.juchuYmdFrom : '',
            kamotsuJuchuYmdTo: self.conditions.juchuYmdTo ? self.conditions.juchuYmdTo : '',
            kamotsuSeikyuYmdFrom: self.conditions.seikyuYmdFrom ? self.conditions.seikyuYmdFrom : '',
            kamotsuSeikyuYmdTo: self.conditions.seikyuYmdTo ? self.conditions.seikyuYmdTo : '',
            kamotsuJuchuEigyoshoCd: self.conditions.juchuEigyoshoCd ? self.conditions.juchuEigyoshoCd : '',
            kamotsuSagyoEigyoshoCd: self.conditions.sagyoEigyoshoCd ? self.conditions.sagyoEigyoshoCd : '',
            kamotsuNinushiCd: self.conditions.ninushiCd ? self.conditions.ninushiCd : '',
            kamotsuNippoStatus: self.conditions.nippoStatus,
            kamotsuMiseikyuTaishoFlg: self.conditions.miseikyuTaishoFlg,
            kamotsuKingakuFuseigoFlg: self.conditions.kingakuFuseigoFlg
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
        this.searchText = ''
        this.rows = []
        this.selectedItem = []
      })
      this.Effects.loadComplete()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', undefined)
      this.searchText = ''
      this.rows = []
      this.selectedItem = []
      console.log('emited', this.showDialog)
      // this.clear(false)
    },
    searchValidate: function () {
      var msg
      if (this.conditions.juchuYmdFrom && this.conditions.juchuYmdTo) {
        msg = validators.compareDate(this.conditions.juchuYmdFrom, this.conditions.juchuYmdTo)
        if (msg !== undefined) {
          this.$refs.juchuYmdFrom[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.juchuYmdTo[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.conditions.seikyuYmdFrom && this.conditions.seikyuYmdTo) {
        msg = validators.compareDate(this.conditions.seikyuYmdFrom, this.conditions.seikyuYmdTo)
        if (msg !== undefined) {
          this.$refs.seikyuYmdFrom[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.seikyuYmdTo[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        juchuYmdFrom: '',
        juchuYmdTo: '',
        seikyuYmdFrom: '',
        seikyuYmdTo: '',
        juchuEigyoshoCd: '',
        sagyoEigyoshoCd: '',
        ninushiCd: '',
        nippoStatus: '99',
        miseikyuTaishoFlg: true,
        kingakuFuseigoFlg: false
      }
      this.$set(this, 'page', 0)
      this.$set(this, 'page', 1)
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
  z-index: 400 !important;
}
</style>
